import script from "./StickySupportButton.vue?vue&type=script&setup=true&lang=js"
export * from "./StickySupportButton.vue?vue&type=script&setup=true&lang=js"

import "./StickySupportButton.vue?vue&type=style&index=0&id=3d4107eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4107eb"]])

export default __exports__